"use strict";
import React from "react";
import classNames from "classnames";
import reactUtils from "../../react_utils";
import Account from "../../api/account";
import Auth from "../../util/auth";
import { shouldShowIndexShipmentSelector } from "../document_assignment/document_assignment_loader";
import {
  DocumentPODDisposition
} from "../data/types/Pb";
import {
  getLoadRelationshipForDocument,
  isPodForLoad
} from "../helpers/document_load_relationship_helpers";
var bem = reactUtils.makeBem("load-assigner-progress");
export default React.createClass({
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, Account.indexAuditSplitEnabled() ? /* @__PURE__ */ React.createElement("div", null, this.indicators()) : null, /* @__PURE__ */ React.createElement("div", null, this.props.content));
  },
  indicators() {
    return this.props.items.map(
      (item) => indicator(item.text, item.isFullfilled, item.isWarning, item.isAutomated)
    );
  }
});
function indicator(text, isFulfilled, isWarning, isAutomated) {
  const classes = classNames({
    [`${bem("__pill")}`]: true,
    [`${bem("__pill__gray")}`]: !isFulfilled && !isWarning,
    [`${bem("__pill__complete")}`]: isFulfilled && !isAutomated,
    [`${bem("__pill__automated")}`]: isFulfilled && isAutomated,
    [`${bem("__pill__warning")}`]: isWarning
  });
  let icon = "icon-checkmark-circle-grey";
  if (isFulfilled) {
    icon = "icon-checkmark-circle-green";
  } else if (isWarning) {
    icon = "icon-warning";
  }
  return /* @__PURE__ */ React.createElement("span", { className: classes, key: text }, /* @__PURE__ */ React.createElement("span", { className: `${icon} icon--no-repeat icon--sm` }), text);
}
function isAutomatedPodCheck(documents, selectedLoad, hasPod, documentLoadRelationships) {
  if (!Account.showPodDispositionOnIndexing()) return false;
  if (!Auth.getCurrentUser().managed_indexer) return false;
  if (hasPod) return false;
  const bols = documents.filter((doc) => doc.type === "billOfLading");
  if (bols.length === 0) return false;
  return bols.every((doc) => {
    const rel = getLoadRelationshipForDocument(
      doc,
      selectedLoad,
      documentLoadRelationships
    );
    return (rel == null ? void 0 : rel.pod_disposition) === DocumentPODDisposition.DocumentPODDispositionKnownNotPOD;
  });
}
function multiShipmentBoxesEnabled(selectedLoad, documentBatch) {
  return documentBatch.documents.some(
    (doc) => shouldShowIndexShipmentSelector(
      selectedLoad,
      doc,
      Account.currentSettings(),
      "index"
    )
  );
}
function markPODForShipmentsItem(shipmentDocumentSelections, selectedLoad, documentLoadRelationships) {
  const everyShipmentHasPod = shipmentDocumentSelections.every(
    (shipmentDocumentSelection) => {
      return shipmentDocumentSelection.documents.some(
        (doc) => isPodForLoad(doc, selectedLoad, documentLoadRelationships)
      );
    }
  );
  return {
    text: "Mark POD for shipments",
    isFullfilled: everyShipmentHasPod,
    isWarning: false
  };
}
function markPODItem(documentBatch, currentDocGroup, selectedLoad, documentLoadRelationships) {
  const groupDocs = documentBatch.documents.filter(
    (x) => x.document_group_id === currentDocGroup.id
  );
  const hasPod = groupDocs.some(
    (doc) => isPodForLoad(doc, selectedLoad, documentLoadRelationships)
  );
  const automated = isAutomatedPodCheck(
    groupDocs,
    selectedLoad,
    hasPod,
    documentLoadRelationships
  );
  return {
    text: automated ? "Automation: POD Check" : "Mark POD",
    isFullfilled: hasPod || automated,
    isWarning: false,
    isAutomated: automated
  };
}
function linkCustomerDocsToShipments(documentBatch, shipmentDocumentSelections) {
  const customerVisibleDocTypes = Account.customerVisibleDocumentTypes();
  const customerDocs = documentBatch.documents.filter((doc) => {
    return customerVisibleDocTypes.includes(doc.type);
  });
  const everyDocHasShipment = customerDocs.every((doc) => {
    return shipmentDocumentSelections.some((shipmentDocumentSelection) => {
      return shipmentDocumentSelection.documents.some(
        (shipmentDoc) => shipmentDoc.id === doc.id
      );
    });
  });
  return {
    text: "Link customer documents to shipments",
    isFullfilled: everyDocHasShipment,
    isWarning: false
  };
}
export function getLoadAssignerProgressItems(selectedLoad, documentBatch, currentDocGroup, invoiceDataEntered, shipmentDocumentSelections, rerouteNidfToException, documentLoadRelationships) {
  const items = [
    { text: "Assign Load", isFullfilled: !!selectedLoad, isWarning: false },
    {
      text: "Verify Invoice data",
      isFullfilled: !!selectedLoad && invoiceDataEntered,
      isWarning: false
    }
  ];
  const showMarkPOD = !selectedLoad || selectedLoad && !selectedLoad.requires_auditor_manual_marking_of_POD;
  if (multiShipmentBoxesEnabled(selectedLoad, documentBatch)) {
    if (showMarkPOD) {
      items.push(
        markPODForShipmentsItem(
          shipmentDocumentSelections,
          selectedLoad,
          documentLoadRelationships
        )
      );
    }
    items.push(
      linkCustomerDocsToShipments(documentBatch, shipmentDocumentSelections)
    );
  } else {
    if (showMarkPOD) {
      items.push(
        markPODItem(
          documentBatch,
          currentDocGroup,
          selectedLoad,
          documentLoadRelationships
        )
      );
    }
  }
  if (rerouteNidfToException) {
    items.push({ text: "Custom rules", isFullfilled: false, isWarning: true });
  }
  return items;
}
